var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgXyte = function SvgXyte(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#FFC400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5098 24.2847C25.1057 24.6888 24.8787 25.237 24.8787 25.8085C24.8787 26.3801 25.1057 26.9282 25.5098 27.3324L28.6395 30.4622L28.6728 30.4954L30.9997 28.1684L26.313 23.4814L25.5098 24.2847Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6681 14.5L22.9955 20.1729L17.3604 14.5374L17.3271 14.5042L15 16.8313L20.6685 22.5L15.0044 28.1731L17.3313 30.5L30.995 16.8271L28.6681 14.5Z",
    fill: "#424242"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXyte);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "xyte.179920fbe75880080a7d90a8cc8b1438.svg";